/**
 * GlcControllerOnOff Style01 - On/Off (reuse OnOff)
 */
import type { TraitControlProps } from './types'
import { OnOffStyle01 } from './OnOffStyle01'

export function GlcControllerOnOffStyle01(props: TraitControlProps) {
  return <OnOffStyle01 {...props} />
}
